module.exports = __webpack_public_path__ + "static/media/chartCirclePayed.5579cad4.svg";